export enum Prefix {
  FDA = 'fda',
  PMS = 'pms',
  CONFIDENTIALITY = 'confidentiality',
}
